import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { ETypeDomain } from "../../../../config/types";
import { RelatorioMensalReceitaAModel } from "../../../../views/pages/private/relatorios/models/relatorio-models";
import { useApiBase } from "../../base/api-base";

export function useGerarRelatorioRMNRA() {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const gerarRelatorioRMNRA = useCallback(
    (filtros: RelatorioMensalReceitaAModel) => {
      return invocarApi({
        url: `Relatorio/relatorio-rmnra`,
        method: "POST",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(filtros),
        baseURL: VariaveisAmbiente.apiUrl,
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    gerarRelatorioRMNRA,
  };

}